<script>
    import Bar from './Bar.svelte';
    import BarItem from './BarItem.svelte';
    import BarItems from './BarItems.svelte';
    export let value; // the row specification from pageIndex
    const choices = [
        ['r01', "JANUARY"],
        ['r03', "FEBRUARY"],
        ['r05', "MARCH"],
        ['r07', "APRIL"],
        ['r09', "MAY"],
        ['r11', "JUNE"],
        ['r13', "JULY"],
        ['r15', "AUGUST"],
        ['r17', "SEPTEMBER"],
        ['r19', "OCTOBER"],
        ['r21', "NOVEMBER"],
        ['r23', "DECEMBER"],
        ['r25', "ENDING"],
    ];
    const keys = new Set(choices.map(c => c[0]));
</script>

{#if keys.has(value)}
    <Bar icon="month">
        <BarItems {value} {choices} />
        <BarItem isBigSpacer={true} />
    </Bar>
{/if}